import React, { useState } from "react";
import Message from "./Message";

export function EditableLabel({
  label = "",
  onChange,
  update,
  serverResponse,
  reset,
  readOnly,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const finishEditing = () => {
    setIsEditing(!isEditing);
    if (isEditing) {
      update();
    }
  };

  return (
    <>
      <div className="flex uppercase tracking-wide text-gray-800 text-xs font-bold items-center">
        Booking Link:
        {!readOnly && (
          <button
            type="button"
            className="ml-2 inline-flex items-center bg-transparent text-blue-700 font-semibold hover:underline outline-none focus:outline-none active:outline-none"
            onClick={finishEditing}>
            {isEditing ? (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="fill-current">
                  <path d="M12 20h9"></path>
                  <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                </svg>
                <span className="text-xs ml-1">Editing</span>
              </>
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="fill-current">
                  <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                </svg>
                <span className="text-xs ml-1 mr-2">Edit</span>
              </>
            )}
          </button>
        )}
        {serverResponse && <Message {...serverResponse} reset={reset} micro />}
      </div>
      {isEditing ? (
        <input
          className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
          id="booking_link"
          name="booking_link"
          type="text"
          placeholder="Enter booking link"
          value={label === "" ? "https://" : label}
          onChange={onChange}
          onBlur={finishEditing}
        />
      ) : (
        <a
          className="truncate text-blue-600 hover:underline"
          href={label}
          target="_blank"
          rel="noopener noreferrer">
          {label}
        </a>
      )}
    </>
  );
}
